import React, { useEffect, useRef, useState } from 'react';
import Layout from '../../components/layout';
import Header from '../../components/header';
import { URLS } from '../../_config';
import Icon from '../../components/icons';
import { AgGridReact } from 'ag-grid-react';
import { data, useLocation, useNavigate } from 'react-router-dom';
import Drawer from '../../components/Drawer';
//import CreateAssets from './_components/createAssets';
import { Dropdown, Menu } from '../../components/Dropdown';
import Button from '../../components/elements/button';
import { useAssetsApi } from '../../store/api/hooks/assetsApiHook';
import Search from '../../components/search';
import moment from 'moment';
//import StatusChangeReasonModal from './_components/statusChangeReason.modal';
import { statusChangeDataType } from '../../_common/types';
import { useDialog } from '../../store/api/hooks/dialogHook';
import toast from 'react-hot-toast';
import { DATE_FORMAT, PAGE_SIZE } from '../../_common/constant';
import Pagination from '../../components/pagination';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import axios from 'axios';
import { downloadExcel, downloadPDF, getPermissionInfo, showLocalDate } from '../../_common/functions';
import Loader from '../../components/loader';
import { filterConfigType } from '../../_config/types';
import Filters from '../../components/filters';
import { useAssestCategoriesSelector, useAssestClassificationsSelector, useAssestDepartmentsSelector, useAssestGroupsSelector, useAssestStatuesSelector, useAssestSubGroupsSelector, useAssestTypesSelector } from '../../store/selectors/masterSelector';
import { useFacilitiesApi } from '../../store/api/hooks/facilitiesApiHook';
import { titleCell } from '../../components/elements/function';
import AssetStatus from '../Assets/_components/assetStatus';
import { useUserSelector } from '../../store/selectors/userSelector';
import { useAppLoader } from '../../_common/pageLoader/appLoaderHook';
//import MoveAssetModal from './_components/moveAsset.modal';
//import AssetStatus from './_components/assetStatus';

const WipAssets: React.FC = () => {
    const { confirm } = useDialog();

    // Define row data    
    const [copyData, setCopyData] = useState<any>(null);
    const [assetData, setAssetData] = useState<any>(null);
    const [actionType, setActionType] = useState<"edit" | "duplicate" | 'add' | null>(null);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchParam, setSearchParam] = useState<string>('');
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [gridApi, setGridApi] = useState<any>(null);
    const [gridColumnApi, setGridColumnApi] = useState<any>(null);
    const [editData, setEditData] = useState<any>(null);
    const [statuslist, setstatusList] = useState<any>(null);
    const [facilityoption, setFacilityoption] = useState<any>([]);
    const [filters, setFilters] = useState<any>({});
    const [filtersApplied, setFiltersApplied] = useState<any>({ generalFilter: false, locationFilter: false });
    const [filtersInitialized, setFiltersInitialized] = useState<boolean>(false);

    // Load filters from localStorage on component mount
    useEffect(() => {
        const savedFilters = localStorage.getItem('wipAssetsFilters');
        if (savedFilters) {
            try {
                const parsedFilters = JSON.parse(savedFilters);
                setFilters(parsedFilters);
            } catch (error) {
                console.error('Error parsing saved filters:', error);
                setFilters({});
            }
        } else {
            setFilters({});
        }
        setFiltersInitialized(true);
    }, []);

    // Save filters to localStorage when filters change
    useEffect(() => {
        if (Object.keys(filters).length > 0) {
            localStorage.setItem('wipAssetsFilters', JSON.stringify(filters));
        }
    }, [filters]);

    const [rowData, setRowData] = useState<any>(null)

    const { showLoader, hideLoader } = useAppLoader();
    const assetsCategories = useAssestCategoriesSelector();
    const assetsDepartments = useAssestDepartmentsSelector();
    const assetsGroups = useAssestGroupsSelector();
    const assetsSubGroups = useAssestSubGroupsSelector();
    const assetsTypes = useAssestTypesSelector();
    const assetsClassifications = useAssestClassificationsSelector();
    const assetsStatues = useAssestStatuesSelector();
    const assetRef = useRef<HTMLDialogElement>(null);
    const addNewAssetRef: any = React.createRef<HTMLButtonElement>();
    const filtersRef: any = useRef();
    const createAssetRef: any = useRef();
    const assetsAPI = useAssetsApi();
    const navigate = useNavigate();
    const facilityApi: any = useFacilitiesApi();
    const location = useLocation();
    const loggedinuser: any = useUserSelector();

    const columnDefs: any = [
        { headerCheckboxSelection: true, checkboxSelection: true, pinned: 'left', width: 50, headerClass: 'bg-[#f0f0f0]' },
        {
            headerName: 'Asset ID', field: 'assetCode', headerClass: 'bg-[#f0f0f0]', pinned: 'left', width: 190, cellRenderer: (data: any) => {
                return (
                    <p className='hover:text-primary font-semibold cursor-pointer' title={data.value}>{data.value}</p>
                )
            }, onCellClicked: (param: any) => {
                navigate(URLS.ASSETS_DETAILS(param.data.assetID));
            }
        },
        {
            headerName: 'Asset Name', field: 'name', headerClass: 'bg-[#f0f0f0]', pinned: 'left', width: 300,
            cellRenderer: (data: any) => {
                return (
                    <p className='hover:text-primary font-semibold cursor-pointer' title={data.value}>{data.value}</p>
                )
            }, onCellClicked: (param: any) => {
                navigate(URLS.ASSETS_DETAILS(param.data.assetID));
            }
        },
        { headerName: 'Category', field: 'categoryName', headerClass: 'bg-[#f0f0f0]', width: 160, cellRenderer: titleCell },
        { headerName: 'Facility Name', field: 'facilityName', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 160, cellRenderer: titleCell },
        {
            headerName: 'Status', field: 'statusName', headerClass: 'bg-[#f0f0f0]', width: 200, cellStyle: {
                alignItems: 'center'
            }, cellRenderer: (data: any) => {
                return (
                    <div className={`pointer-events-none cursor-not-allowed flex justify-center h-full flex-col`}>
                        {/* <AssetStatus
                            asset={data.data}
                            onUpdate={getAssetsList}
                        /> */}
                        <div className='flex items-center gap-2 h-full'>
                            <div className='w-[0.5rem] h-[0.5rem] rounded-full bg-red-700 flex-shrink-0'></div>
                            <select
                                className="status-dropdown flex-grow"
                            >
                                {[{ value: data.data.statusID, label: data.data.statusName }]?.map((status: any) => {
                                    return (
                                        <option value={status.value} selected={data.data.statusID == status.value}>{status.label}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                )
            }
        },
        {
            headerName: 'Last Maintenance Date', field: 'lastMaintenanceDate', headerClass: 'bg-[#f0f0f0]', width: 200,
            cellRenderer: (data: any) => {
                return (
                    <p className='hover:text-primary font-semibold cursor-pointer'>{showLocalDate(data.value)}</p>
                )
            }
        },
        {
            headerName: 'Warranty Expiry Date', field: 'warrantyEndDate', headerClass: 'bg-[#f0f0f0]', width: 100,
            cellRenderer: (data: any) => {
                return (
                    <p className='hover:text-primary font-semibold cursor-pointer'>{showLocalDate(data.value)}</p>
                )
            }
        },
        {
            headerName: 'Action',
            field: 'action',
            headerClass: 'bg-[#f0f0f0] text-center',
            pinned: 'right',
            width: 90,
            cellRenderer: (params: any) => {
                return (
                    <div className='relative h-full w-full flex items-center justify-center'>
                        <Icon name='threedote' size={1.25} className='text-[#000000]' onClick={(e: any) => {
                            e.stopPropagation();
                            e.preventDefault();
                            const dropdown: any = document.querySelector('.action-dropdown');
                            if (dropdown) {
                                dropdown.focus();
                            }
                            return false;
                        }} />
                        <select
                            className="action-dropdown"
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                opacity: 0,
                                cursor: "pointer",
                            }}
                            onChange={(e) => {
                                const action = e.target.value;
                                if (!getPermissionInfo(location.pathname, action ==="approved"? "Approve": action, loggedinuser)) {
                                    toast.error(`You don't have ${action} permission`);
                                    e.target.selectedIndex = -1;
                                    return;
                                }
                                handleActionChange(e, params);
                                //e.target.value = '';
                            }}
                            onFocus={(e) => {
                                e.target.selectedIndex = -1;
                            }}
                        >
                            <option value="approved" disabled={!getPermissionInfo(location.pathname, "Approve", loggedinuser)}>Approved</option>
                            //assetGroupID && assetSubGroupID && sageFacilityIDForAccounting
                        </select>
                    </div>
                );
            }
        }
    ];
    const filterConfig: filterConfigType[] = [
        { name: 'Name', type: 'text', key: 'assetName' },
        { name: 'Asset Category', type: 'dropdown', key: 'assetCategoryIDs', options: assetsCategories ? assetsCategories : [] },
        { name: 'Department', type: 'dropdown', key: 'departmentIDs', options: assetsDepartments ? assetsDepartments : [] },
        { name: 'Ownership Type', type: 'dropdown', key: 'accountGroupIDs', options: assetsGroups ? assetsGroups : [] },
        { name: 'Asset Group', type: 'dropdown', key: 'assetSubGroupIDs', options: assetsSubGroups ? assetsSubGroups : [] },
        /* { name: 'Type', type: 'dropdown', key: 'assetTypeIDs', options: assetsTypes ? assetsTypes : [] },
        { name: 'Classification', type: 'dropdown', key: 'assetClassificationIDs', options: assetsClassifications ? assetsClassifications : [] }, */
        //{ name: 'Status', type: 'dropdown', key: 'statusIDs', options: assetsStatues ? assetsStatues : [] },
    ];




    const getfacilitylist = () => {
        facilityApi.getFacilityList({}, (resp: any) => {
            let facilitylist: any = [];
            resp.facilityList.map((facility: any) => {
                facilitylist.push({ label: facility.facilityName, value: facility.facilityID, data: facility });
            });
            setFacilityoption(facilitylist);
        }, (error: any) => {
            console.log("error =>", error);
            toast.error(error);
        });
    };

    const onGridReady = (params: any) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };
    const onRowClicked = (event: any) => {
        if (!event.event.target.closest('input[type="checkbox"]')) {
            event.node.setSelected(false); // Unselect row if it's clicked, not by checkbox
        }
    };
    const getSelectedRows = () => {
        const selectedNodes = gridApi?.getSelectedNodes();
        const selectedData = selectedNodes.map((node: any) => node.data);
        return selectedData;
    };

    const onBulkMoveAssets = () => {
        const selectedData = getSelectedRows();
        if (selectedData.length == 0) {
            toast.error("Nothing is selected")
        } else {
            setAssetData(selectedData);
            assetRef.current?.showModal();
        }
    };
    const onBulkExport = () => {
        const selectedData = getSelectedRows();
        console.log("Selected Data for Deletion:", selectedData);
    };
    const onBulkExportPdf = () => {
        const selectedData = getSelectedRows();
        console.log("Selected Data for Deletion:", selectedData);
        if (selectedData.length == 0) {
            toast.error("Nothing is selected")
        } else {
            const assetIDs = selectedData.map((asset: any) => asset.assetID).join(',');
            const payload = { assetIDs: assetIDs };
            assetsAPI.Exportpdf(
                payload,
                (resp: any) => {
                    downloadPDF(resp, 'assets')
                },
                (error: any) => {
                    console.log("error =>", error);
                    toast.error(error);
                }
            );
        }
    };
    const onBulkExportCsv = async () => {
        const selectedData = getSelectedRows();
        if (selectedData.length == 0) {
            toast.error("Nothing is selected")
        } else {
            const assetIDs = selectedData.map((asset: any) => asset.assetID).join(',');
            const payload = { assetIDs: assetIDs };
            assetsAPI.Exportcsv(
                payload,
                (resp: any) => { downloadExcel(resp, 'assets') },
                (error: any) => {
                    console.log("error =>", error);
                    toast.error(error);
                }
            );
        }
    };
    const onBulkPrintQR = () => {
        const selectedData = getSelectedRows();
        if (selectedData.length == 0) {
            toast.error("Nothing is selected")
        } else {
            let qrAssetList: any = [];
            selectedData?.map((asset: any) => qrAssetList.push({ assetID: asset.assetID, qty: 1 }));
            const payload = { qrAssetList: qrAssetList, assetNameInQR: true };
            assetsAPI.ExportQrCode(payload, (resp: any) => { downloadPDF(resp, 'assets') },
                (error: any) => {
                    console.log("error =>", error);
                    toast.error(error);
                }
            );
        }
    };

    const GetAssetStatusList = () => {
        assetsAPI.GetAssetStatusList({}, (resp: any) => {
            let deptlist: any = [];
            resp.assetStatusList.filter((o: any) => o.isVisible).map((facilist: any) => {
                deptlist.push({
                    label: facilist.statusName,
                    value: facilist.statusID,
                });
            });
            setstatusList(deptlist);
        }, (error: any) => {
            console.log("error =>", error);
            toast.error(error);
        });
    };

    const handleActionChange = (e: any, params: any) => {
        const action = e.target.value;
        const rowData = params.data;

        // Check permission before performing any action
        /* if (!getPermissionInfo(location.pathname, action, loggedinuser)) {
            toast.error(`You don't have ${action} permission`);
            e.target.selectedIndex = -1;
            return;
        } */

        switch (action) {
            case `approved`: {
                // Validate mandatory fields before approval
                if (rowData.assetGroupID == null || rowData.assetSubGroupID == null || rowData.sageFacilityIDForAccounting == null) {
                    toast.error("Mandatory fields like Ownership Type, Asset Group, Asset Sage Facility and Depreciation (where applicable) must be done before approving WIP Asset");
                    return;
                }

                confirm({
                    type: `warn`,
                    title: 'Approve Asset',
                    message: 'Are you sure you want to approve this asset?',
                    onConfirm: async () => {
                        showLoader();
                        const assetupdateresp: any = await new Promise((resolve, reject) => {
                            assetsAPI.updateStatus({
                                assetID: rowData.assetID,
                                assetStatusID: 1,
                                reason: `Approved by ${loggedinuser?.firstName} ${loggedinuser?.lastName}`,
                            }, (resp: any) => {
                                resolve(resp);
                            }, (err: any) => {
                                reject(err);
                            });
                        }).catch((err) => {
                            return null
                        });
                        hideLoader();
                        if (assetupdateresp && assetupdateresp.hasOwnProperty(`successful`) && assetupdateresp.successful) {
                            toast.success(assetupdateresp.message ? assetupdateresp.message : 'WIP status approved successfully');
                            getAssetsList();
                        } else {
                            toast.error(assetupdateresp.message ? assetupdateresp.message : 'Failed to approve WIP status!');
                        }
                    }
                });
                break;
            }
            default:
                console.log("Unknown action: ", action);
                break;
        }
        e.target.selectedIndex = -1;
    };

    const getAssetsList = () => {
        let payload: any = {
            pageSize: PAGE_SIZE,
            pageNumber: currentPage,
            searchParam: searchParam
        };
        if (filters) {
            Object.keys(filters).map((key: any) => {
                if (filters[key]) {
                    payload[key] = filters[key];
                }
            });
        }
        if (!payload.hasOwnProperty(`statusIDs`) || (payload.hasOwnProperty(`statusIDs`) && !payload.statusIDs)) {
            payload.statusIDs = [9].join(`,`);
            //payload.statusIDs = [1, 2, 3, 4, 5, 6].join(`,`);
        }
        assetsAPI.getAssetsList(payload, (data: any) => {
            setRowData(data.assetList ? data.assetList : []);
            setTotalRecords(data.totalRecord);
        }, (error: any) => { });
    };



    useEffect(() => {
        if (assetsCategories == null) {
            assetsAPI.getAssetCategpry({}, (resp: any) => { }, (error: any) => { });
        }
    }, [assetsCategories]);

    useEffect(() => {
        if (assetsDepartments == null) {
            assetsAPI.getAssetdepartment({pageSize: 5000,
                pageNumber: 1,}, (resp: any) => { }, (error: any) => { });
        }
    }, [assetsDepartments]);

    useEffect(() => {
        if (assetsGroups == null) {
            assetsAPI.getAssetGrouplist({}, (resp: any) => { }, (error: any) => { });
        }
    }, [assetsGroups]);

    useEffect(() => {
        if (assetsSubGroups == null) {
            assetsAPI.getAssetSubGrouplist({}, (resp: any) => { }, (error: any) => { });
        }
    }, [assetsSubGroups]);

    useEffect(() => {
        if (assetsTypes == null) {
            assetsAPI.GetAssetTypeList({}, (resp: any) => { }, (error: any) => { });
        }
    }, [assetsTypes]);

    useEffect(() => {
        if (assetsClassifications == null) {
            assetsAPI.GetAssetClassificationList({}, (resp: any) => { }, (error: any) => { });
        }
    }, [assetsClassifications]);

    useEffect(() => {
        if (assetsStatues == null) {
            assetsAPI.GetAssetStatusList({}, (resp: any) => { }, (error: any) => { });
        }
    }, [assetsStatues]);

    useEffect(() => {
        getfacilitylist();
        GetAssetStatusList();
    }, []);

    // Call getAssetsList only after filters are initialized
    useEffect(() => {
        if (filtersInitialized) {
            getAssetsList();
        }
    }, [filters, filtersInitialized]);

    useEffect(() => {
        console.log("statuslist", statuslist);
    }, [statuslist]);

    useEffect(() => {
        if (filtersInitialized) {
            getAssetsList();
        }
        
        const hasActiveFilters = filterConfig.some((filter) => filters[filter.key]);
        const hasActiveLocationFilter = filters?.hasOwnProperty("facilityIDs");
        setFiltersApplied({
            generalFilter: hasActiveFilters,
            locationFilter: hasActiveLocationFilter,
        });
    }, [currentPage, searchParam, filters]);

    // console.log("statuslist", statuslist);

    return (
        <Layout>
            <Header title='WIP Assets'>
                <Header.Right>
                </Header.Right>
            </Header>
            <div className='flex items-center justify-between pl-5 pr-3 border-b border-gray-200 h-[3.75rem]'>
                <Pagination
                    perPage={PAGE_SIZE}
                    totalRecords={totalRecords}
                    onPageChange={setCurrentPage}
                    currentPage={currentPage}
                />
                <Search onSearch={setSearchParam} placeholder='Search by name or serial number' />
            </div>
            <div className='bg-[#FAFAFA]'>
                <div className='flex gap-4 px-5 py-2 items-center'>
                    <Button theme='light' onClick={() => filtersRef.current.showModal()}>Filter <Icon name='filter' size={1.40} className={filtersApplied.generalFilter ? "text-blue-700" : ""} /></Button>
                    <Dropdown>
                        <Dropdown.Button>
                            <Button theme='light'><Icon name='grlocation' size={1.20} className={filtersApplied.locationFilter ? "text-blue-700" : ""} /> Location <Icon name='arrowdown' size={1.10} /></Button>
                        </Dropdown.Button>
                        <Dropdown.Content >
                            {facilityoption?.map((facility: any) => {
                                return (
                                    <Menu onClick={() => {
                                        console.log('facility', facility);
                                        setFilters({ ...filters, facilityIDs: [facility.value] })
                                    }}>{facility.label}</Menu>
                                )
                            }
                            )}
                        </Dropdown.Content>
                    </Dropdown>
                    <p className='text-primary font-semibold text-sm cursor-pointer' onClick={() => { 
                        setFilters({});
                        localStorage.removeItem('wipAssetsFilters');
                    }} >Clear Filters</p>
                </div>

                <div className="ag-theme-alpine mx-4  h-1/2">
                    <AgGridReact
                        columnDefs={columnDefs} // Pass columnDefs
                        rowData={rowData || []} // Pass rowData
                        pagination={false}
                        rowSelection="multiple"
                        onGridReady={onGridReady}
                        domLayout="autoHeight"
                        onRowClicked={onRowClicked}
                        loadingOverlayComponent={Loader}
                        noRowsOverlayComponent={() => (
                            <div className="flex items-center justify-center h-full">
                                <div className="text-center text-gray-500">
                                    <div className="text-lg font-medium">No Data Found</div>
                                </div>
                            </div>
                        )}
                    />
                </div>
            </div>
            <Filters _ref={filtersRef} config={filterConfig} filters={filters} onUpdate={setFilters} />

        </Layout>
    );
};

export default WipAssets;
